import { useEffect } from 'react';

/**
 * Custom hook to trap and disable browser back button navigation
 * @param {boolean} enabled - Whether back button prevention is active
 */
export function usePreventBack(enabled = true) {
    useEffect(() => {
        if (!enabled) return;

        // Push current state to history stack to trap back action
        window.history.pushState(null, "", window.location.href);

        const handlePopState = () => {
            // Re-push state immediately when user clicks back button
            window.history.pushState(null, "", window.location.href);
        };

        window.addEventListener('popstate', handlePopState);

        return () => {
            window.removeEventListener('popstate', handlePopState);
        };
    }, [enabled]);
}
